import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProtectedRoute from './ProtectedRoute';
import { getApiUrl } from '../utils/apiUrl';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, loading: authLoading, getAuthToken } = useAuth();
  const [adminCheckLoading, setAdminCheckLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      if (!user) {
        setAdminCheckLoading(false);
        return;
      }
      try {
        const token = await getAuthToken();
        if (!token) {
          setIsAdmin(false);
          return;
        }
        const baseUrl = getApiUrl().replace(/\/api\/?$/, '');
        const response = await fetch(`${baseUrl}/api/auth/is-admin`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.ok) {
          const data = await response.json();
          setIsAdmin(data.isAdmin === true);
        } else {
          setIsAdmin(false);
        }
      } catch {
        setIsAdmin(false);
      } finally {
        setAdminCheckLoading(false);
      }
    };
    checkAdmin();
  }, [user, getAuthToken]);

  return (
    <ProtectedRoute>
      {authLoading || adminCheckLoading ? (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4">
              <div className="hexagon bg-gradient-to-r from-hexagon to-hexagon-dark animate-pulse"></div>
            </div>
            <p className="text-gray-600">Loading...</p>
          </div>
        </div>
      ) : !isAdmin ? (
        <Navigate to="/dashboard" replace />
      ) : (
        children
      )}
    </ProtectedRoute>
  );
};

export default AdminRoute;
